import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import NavbarLink from './navbar-link';

const NavbarItem = forwardRef((props, ref) => {
    const { item = {}, itemsBasePath, className, isLink, clickHandler, key } = props;
    const { properties: { link = '', target = '' } = {} } = item;
    let url = '';
    if (link) {
        url = link.includes('http') ? link : `${itemsBasePath}${link}`;
    }

    return (
        <li
            className={className}
            key={key}
            aria-expanded="false"
            aria-haspopup="false"
            aria-label={item.text}
            ref={ref}
        >
            <NavbarLink isLink={isLink} key={item.id} url={url} target={target} clickHandler={clickHandler} text={item.text}/>
        </li>
    );
});

NavbarItem.propTypes = {
    className: PropTypes.string,
    clickHandler: PropTypes.func,
    isLink: PropTypes.bool,
    itemsBasePath: PropTypes.string,
    item: PropTypes.shape({
        id: PropTypes.string,
        text: PropTypes.string
    }).isRequired,
    url: PropTypes.string
}

NavbarItem.defaultProps = {
    className: 'navbar__item',
    itemsBasePath: '',
    url: '/video',
    isLink: true
};

export default NavbarItem;
